import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { CheckoutForm } from "@/modules/checkout";
import TopNav from "@/molecules/navbars/TopNav";
import { Models } from "api/types";

type CheckoutContainerProps = {
  platform: Models<"PlatformModel">;
  isGiftCardCreatedUser?: boolean;
  cartDetails: Models<"ShopDisplayOrderResult"> | null;
  transactionDetails: Models<"InitiateOrderTransactionResult"> | null;
  user: Models<"UserModel1"> | null;
  showNavbar: boolean;
};

export const CheckoutContainer = ({
  cartDetails,
  transactionDetails,
  user,
  platform,
  showNavbar,
}: CheckoutContainerProps) => {
  const navigate = useNavigate();
  return (
    <div className="CheckoutContainer">
      {showNavbar && (
        <TopNav
          startIconSVG={ChevronLeft}
          onStartIconClick={() => {
            navigate(-1);
          }}
          showHeaderItems={false}
        >
          <div className="flex max-h-[32px] items-center">
            <div className="flex w-full items-center justify-center text-sub2 text-primary">
              CHECKOUT
            </div>
          </div>
        </TopNav>
      )}
      <CheckoutForm
        cartDetails={cartDetails as Models<"ShopDisplayOrderResult">}
        platform={platform}
        user={user as Models<"UserModel1">}
        transactionDetails={transactionDetails}
      />
    </div>
  );
};
